import { combineReducers } from 'redux';
import { dlpProductReducer } from 'state/secondaryMarket/referential/dlpProduct/dlpProduct.reducer';

import { clientReducer } from './astroClient/astroClient.reducer';
import { legacyProductReducer } from './astroProduct/astroProduct.reducer';
import { bcsProductReducer } from './bcsProduct/bcsProduct.reducer';
import type { SharedReferential } from './referential.model';

export const sharedReferentialReducer = combineReducers<SharedReferential>({
  astroClient: clientReducer,
  astroProduct: legacyProductReducer,
  bcsProduct: bcsProductReducer,
  dlpProduct: dlpProductReducer,
});
